// extracted by css-extract-rspack-plugin
export default {"heading":"heading-hjFikc","groupLabel":"groupLabel-v88yX8","entityText":"entityText-vHP_P1"};